<pathPantalla></pathPantalla>
<div [hidden]="consulta">
  <div class="row">
    <div class="col-lg-12" style="padding: 0px">
        <section class="widget">
            <!-- título -->
            <header>
                <h3> {{sistemaService.NombrePantallaActual}} </h3>
            </header>
            <div class="separador"></div>

        </section>

        <div class="divisor8"></div>

      <div class="row">
          <div class="col-lg-12" style="padding: 0px">
              <section class="widget">

                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                      <dropdownCustom [titulo]="'Periodo de evaluación'" valorName="periodoevaluacionid"
                      displayValor="descripcion" propiedad="periodoevaluacionid"
                      [opciones]="listaperiodoevaluacion" [(ngModel)]="periodoevaluacion"
                      (ngModelChange)="tipoevaluacion($event)"></dropdownCustom>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                    <button class="boton botonSM filled" *ngIf="periodoevaluacion > 0" matTooltip="Refresca la información en tabla" (click)="tipoevaluacion(periodoevaluacion)" >Actualizar estatus de las evaluaciones</button>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12 col-12" style="padding-right: 0;">
                    <button class="boton botonSM  botonDerecha filled" *ngIf="periodoevaluacion > 0" (click)="EliminacionGeneral(periodoevaluacion)">Eliminar todas las evaluaciones</button>
                  </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-12" style="text-align: right;">
                <i class="fa fa-question-circle" style="font-size: 20px; color: #000; cursor: pointer;" (click)="mostrarInfo()"></i>
              </div>
              <br>
              <div>
                <dx-data-grid
                (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                id="tabla"
                [columnAutoWidth]="true"
                [dataSource]="SelDataPeriodoporTipo"
                [noDataText]="'Sin Datos'"
                [hoverStateEnabled]="true"
                [showColumnHeaders]="true"
                >
                <dxo-export [enabled]="false" [fileName]="sistemaService.NombrePantallaActual" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                <dxo-search-panel
                    [visible]="true"
                    [width]="240"
                    placeholder="{{'Buscar' | translate}}">
                </dxo-search-panel>

                <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                <dxo-pager
                    [visible]="true"
                    [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                    [displayMode]="sistemaService.tablaPaginacionModo"
                    [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                    [showInfo]="sistemaService.tablaPaginacionInfo"
                    [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                </dxo-pager>
                <dxi-column
                    dataField="nombre"
                    caption="Tipo de evaluación">
                </dxi-column>
                <dxi-column
                    dataField="nivel"
                    caption="Nivel">
                </dxi-column>
                <dxi-column
                    dataField="fechainicioevaluacion"
                    caption="Fecha inicio evaluación">
                </dxi-column>
                <dxi-column
                  [allowExporting]="false"
                  caption=""
                  cellTemplate="cellAccionCrear"
                  alignment="center">
                </dxi-column>
                <dxi-column
                  [allowExporting]="false"
                  caption=""
                  cellTemplate="cellAccionActualizar"
                  alignment="center">
                </dxi-column>
                <dxi-column
                  [allowExporting]="false"
                  caption=""
                  cellTemplate="cellAccionEliminar"
                  alignment="center">
                </dxi-column>
                <dxi-column
                [allowExporting]="false"
                caption="Estatus de ejecución"
                cellTemplate="cellEstatus"
                alignment="center"
                [minWidth]="120">
                </dxi-column>
                <dxi-column
                    dataField="usuario"
                    caption="Usuario">
                </dxi-column>
                <dxi-column
                    dataField="fechamodificacion"
                    caption="Fecha/Hora">
                </dxi-column>
                <dxi-column
                  dataField="tipoaccion"
                  caption="Acción realizada">
                </dxi-column>
                <!-- Acciones -->
                <div *dxTemplate="let cell of 'cellEstatus'">
                  <span *ngIf="cell.data.estatusejecucionevaluacionid == 3" style="color: rgb(61, 229, 135);">{{cell.data.estatus}}</span>
                  <span *ngIf="cell.data.estatusejecucionevaluacionid == 2" style="color: rgb(250, 196, 78);">{{cell.data.estatus}}</span>
                  <span *ngIf="cell.data.estatusejecucionevaluacionid == 1" style="color: rgb(255, 88, 88);">{{cell.data.estatus}}</span>
                </div>
                <div *dxTemplate="let accion of 'cellAccionEliminar'">
                  <button class="boton botonSM filled" style="margin-left: 10px;" *ngIf="sistemaService.permisos.eliminar" (click)="reiniciarevaluaciones(accion.data.periodoevaluacionportipoevaluacionid)" [disabled]="accion.data.estatusejecucionevaluacionid != 3 || accion.data.estatusejecucionevaluacionid == 2">Administrar eliminación</button>
                </div>
                <div *dxTemplate="let accion of 'cellAccionCrear'">
                  <button class="boton botonSM filled" style="margin-right: 10px;" (click)="crearevaluaciones(accion.data.periodoevaluacionportipoevaluacionid)" *ngIf="sistemaService.permisos.agregar " [disabled]="accion.data.estatusejecucionevaluacionid != 1 || accion.data.estatusejecucionevaluacionid == 2" matTooltip="Generación de evaluaciones">Crear</button>
                </div>
                <div *dxTemplate="let accion of 'cellAccionActualizar'">
                  <button class="boton botonSM filledBlanco" *ngIf="sistemaService.permisos.editar" (click)="actualizarevaluaciones(accion.data.periodoevaluacionportipoevaluacionid)" [disabled]="accion.data.estatusejecucionevaluacionid != 3 || accion.data.estatusejecucionevaluacionid == 2">Actualizar</button>
                </div>
            </dx-data-grid>
              </div>
              </section>
    </div>
  </div>
    </div>
  </div>
</div>
<div #administrareliminacion></div>
